import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { projectIssueNavigatorRoute } from '@jira/router-routes__issue-navigator-routes/src/projectIssueNavigatorRoute.tsx';
import { ProjectIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/project-app.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getCommonProjectResources } from './common/getCommonProjectResources.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import {
	issueNavigatorPinRedirectPageEntryPoint,
	issueNavigatorPinRedirectPageEntryPointWithoutPreviewPanel,
} from './ui/index.tsx';

export const projectIssueNavigatorRouteEntry: Route = createEntry(
	projectIssueNavigatorRoute,
	() => ({
		group: 'issue-navigator',
		apdexIgnoreParams: ['issueKey'],

		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},

		skeleton: ProjectIssueNavigatorSkeleton,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
		},

		resources: [...getCommonProjectResources(), getConsolidationStateResource()],
		layout: createLayout(genericProjectLayout),
		entryPoint: () =>
			fg('nin_glance_panel_technical_changes')
				? issueNavigatorPinRedirectPageEntryPoint
				: issueNavigatorPinRedirectPageEntryPointWithoutPreviewPanel,
		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
